<div class="flex flex-column mat-elevation-z1 menu">
  @if (node()?.type?.name === SFNodeType.heading) {
    <button mat-icon-button (click)="openEditDialog('tabbed')" matTooltip="Advanced heading settings">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @if (node()?.type?.name === SFNodeType.part) {
    <button
      mat-icon-button
      matTooltip="Edit the chapter settings"
      matTooltipPosition="right"
      (click)="openEditDialog('tabbed')"
      >
      <mat-icon>edit</mat-icon>
    </button>
  }
  @if (node()?.type?.name === SFNodeType.image) {
    <button
      mat-icon-button
      [matTooltip]="node()?.attrs?.decorative ? 'Edit Alt Text (image is decorative)' : node()?.attrs?.alt ? 'Edit Alt Text' : 'Add Alt Text (currently missing)'"
      matTooltipPosition="right"
      (click)="openEditDialog('simple')"
      >
      <mat-icon
        aria-hidden="false"
        [attr.aria-label]="!node()?.attrs?.alt && !node()?.attrs?.decorative ? 'Image alt text missing' : 'Image alt text configured'"
        [matBadge]="!node()?.attrs?.alt && !node()?.attrs?.decorative ? '1' : undefined"
        >add_photo_alternate</mat-icon
        >
      </button>
    }
    @if (node()?.type?.name === SFNodeType.reference) {
      <button
        mat-icon-button
        matTooltip="Promote to reference"
        matTooltipPosition="right"
        (click)="promoteToReference()"
        >
        <mat-icon>publish</mat-icon>
      </button>
    }
    @if (node()?.type?.name !== SFNodeType.part && node()?.type?.name !== SFNodeType.heading) {
      <button
        mat-icon-button
        matTooltip="Delete"
        matTooltipPosition="right"
        (click)="deleteNode()"
        >
        <mat-icon class="negative">delete</mat-icon>
      </button>
    }
  </div>
